<!-- Displays a message with icon warning the user that the out/in journey does not have complete coverage of first class travel over the journey.
@prop percentage - A Number with how much first class coverage of the outbound/inbound journey exists. Can also be boolean false which indicates that a journey has not been selected yet, or the journey is standard class. -->
<script setup lang="ts">
import { isMobile } from "@/utilities/IsMobileHelper";

const props = defineProps<{
    percentage: number | false;
    type: "inbound" | "outbound";
}>();

// Only show the warning if the percentage is not 100% and not false. E.g. if it is 0% but not false then the warning should be shown as the user has seleceted a first class journey but it has not got first class coverage.
function shouldShowWarning() {
    return props.percentage !== false && props.percentage < 100;
}

// On mobile there is no difference between inbound and outbound journeys in the overview, so this needs to be handled in the text.
function getText() {
    if (props.percentage === false) {
        return "";
    }
    if (isMobile()) {
        if (props.type === "outbound") {
            return `Only ${Math.floor(props.percentage)}% of your outward journey is in first class`;
        }
        return `Only ${Math.floor(props.percentage)}% of your return journey is in first class`;
    }
    return "Only " + Math.floor(props.percentage) + "% of travel is in first class";
}

function getIconSize() {
    if (isMobile()) {
        return 15;
    }
    return 18;
}
</script>

<template>
    <span>
        <p style="color: #e65100" v-if="shouldShowWarning()" class="mt-1 text-right message"><v-icon icon="mdi-alert-circle" :size="getIconSize()"></v-icon>{{ getText() }}</p>
    </span>
</template>

<style scoped lang="scss">
@import "@/assets/base.scss";
.message .v-icon {
    margin-right: 4px;
    margin-top: -2px;
}

@media (max-width: $mobile-breakpoint) {
    .message {
        font-size: 0.7rem;
    }
    .message .v-icon {
        margin-right: 2px;
    }
}
</style>
